import React, { forwardRef } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";
import { ChevronUp, ChevronDown } from "react-feather";
const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));
const useStyles = makeStyles((theme) => ({
  root: {
    background: "#2d3239",
    color: "#ffffff",
  },
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: "#ffffff",
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "10px 8px",
    textTransform: "none",
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  title: {
    marginRight: "auto",
    background: "#2d3239",
    color: "#ffffff",
  },
  active: {
    color: 'gray',
    "& $title": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    "& $icon": {
      color: 'gray',
    },
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const NavItem = ({
  className,
  id,
  href,
  icon: Icon,
  title,
  tipo,
  cambioMenuActivo,
  open,
  abrirFormTablero,
  ...rest
}) => {
  const classes = useStyles();
  const atributosButton = [2, 3].includes(tipo)
    ? {
        activeClassName: classes.active,
        //...link,
        component: RouterLink,
        end: true,
        to: href,
      }
    : {
        onClick: cambioMenuActivo(id),
      };
  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        className={clsx(classes.button, tipo === 3 ? classes.nested : null)}
        {...atributosButton}
        endIcon={
          tipo !== 1 ? undefined : open ? <ChevronDown /> : <ChevronUp />
        }
      >
        {Icon && <Icon className={classes.icon} size="20" strokeWidth="2.5" />}
        <span className={classes.title}>{title}</span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavItem;
